import React from 'react'
import {ensureNumber} from '@modifi/typescript-utils'
import {Svg, CommonSvgProps, commonDefaultProps} from '@modifi/ui'

const ratio = 75 / 163

type GroupOwnershipIconProps = CommonSvgProps

const GroupOwnershipIcon = React.forwardRef<SVGSVGElement, GroupOwnershipIconProps>(
  ({height = commonDefaultProps.height, width, ...props}, ref) => (
    <Svg
      viewBox="0 0 156 94"
      {...props}
      height={height}
      width={width ?? ensureNumber(height) / ratio}
      ref={ref}
    >
      <g filter="url(#filter0_d_2201_8579)">
        <rect
          x="49.7109"
          y="1"
          width="56.5702"
          height="35.0358"
          rx="4.20917"
          fill="#7BB835"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2201_8579)">
        <rect
          x="3.49023"
          y="53.209"
          width="56.5702"
          height="35.0358"
          rx="4.20917"
          fill="#53A2D9"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2201_8579)">
        <rect
          x="95.9355"
          y="53.209"
          width="56.5702"
          height="35.0358"
          rx="4.20917"
          fill="#15539F"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <line
        x1="76.968"
        y1="36.0352"
        x2="76.9679"
        y2="44.9659"
        stroke="#B2B3B5"
        strokeWidth="0.701528"
      />
      <line
        x1="32.1242"
        y1="44.9648"
        x2="32.1242"
        y2="53.2086"
        stroke="#B2B3B5"
        strokeWidth="0.701528"
      />
      <line
        x1="124.351"
        y1="44.9648"
        x2="124.351"
        y2="53.2086"
        stroke="#B2B3B5"
        strokeWidth="0.701528"
      />
      <line
        x1="77.3066"
        y1="45.3156"
        x2="31.7746"
        y2="45.3156"
        stroke="#B2B3B5"
        strokeWidth="0.701528"
      />
      <line
        x1="124.219"
        y1="45.3156"
        x2="76.617"
        y2="45.3156"
        stroke="#B2B3B5"
        strokeWidth="0.701528"
      />
      <defs>
        <filter
          id="filter0_d_2201_8579"
          x="46.9048"
          y="0.298472"
          width="62.1825"
          height="40.6484"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.10458" />
          <feGaussianBlur stdDeviation="1.40306" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.952941 0 0 0 0 0.960784 0 0 0 0 0.964706 0 0 0 0.22 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2201_8579" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2201_8579"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2201_8579"
          x="0.684122"
          y="52.5075"
          width="62.1825"
          height="40.6484"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.10458" />
          <feGaussianBlur stdDeviation="1.40306" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.952941 0 0 0 0 0.960784 0 0 0 0 0.964706 0 0 0 0.22 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2201_8579" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2201_8579"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2201_8579"
          x="93.1294"
          y="52.5075"
          width="62.1825"
          height="40.6484"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.10458" />
          <feGaussianBlur stdDeviation="1.40306" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.952941 0 0 0 0 0.960784 0 0 0 0 0.964706 0 0 0 0.22 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2201_8579" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2201_8579"
            result="shape"
          />
        </filter>
      </defs>
    </Svg>
  )
)

export default GroupOwnershipIcon
